import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const WoKehtiThi = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - WO KEHTI THI</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - WO KEHTI THI</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                Yeah<br/>
                Wo Kehti Thi lejana ghar mujhe<br/>
                Wo kehti thi rehna yahapar bas<br/>
                Tu hai jo saath to fir lage na dar mujhe<br/>
                Yeah<br/>
                Wo Kehti Thi<br/>
                Wo Kehti Thi, aasu hi tapke jab tu ho naaraz tujhe kabse mai dekhna chahu yu aakh meri tarse na door ho
                dua meri rab se<br/>
                Wo kehti thi, ab kya rukna keh dena sabhi ko<br/>
                Hai mujhpar hai chodi ye chavi jo<br/>
                Kehdena lage koi kami to<br/>
                Yeah<br/>
                Wo kehti thi, dil se is dil tak ko choolena<br/>
                Hai tere saaye me sukoon har ek vaada kabool bas ye khwaab kabhi toote na<br/>
                Yeah<br/>
                Wo Kethi Thi<br/>
                Wo Kehti Thi, karna is rishte ki dil se hifasat<br/>
                Sirf tu hi kamjori, tu hi meri taaqat<br/>
                Hu kho chuki khudko in baaho me aakar<br/>
                Wo Kehti Thi, dard diya bohot use gairo ne<br/>
                Jindagi beet gayi andhero me ab use dar sa lage in savero se<br/>
                Yeah<br/>
                Wo Kehti Thi, apna banake na door ja<br/>
                Aur mujhse na raha kar yu khafa<br/>
                Hai khud par hi kaabu nai kyu bata<br/>
                Haan?<br/>
                Mai Kehta Tha, bachpan se aise hi sudhre nai<br/>
                Chahat sirf aasman choone ki<br/>
                Filhaal abhi jung meri khud se hi<br/>
                Yeah<br/>
                Wo Sehti Thi, har waqt ki man marzi meri<br/>
                Aur palbhar ki hamdardi meri<br/>
                Thi hasrat bhi, nafrat bhi gehri<br/>
                Yeah<br/>
                Bas aise hi, choot gaya saath uska ek din<br/>
                Aur beet gaye saal use dekhe bin<br/>
                Par ab bhi wo saaf, thi wo nek dil<br/>
                Khair<br/>
                Ab waise bhi, khone ko kuch bhi bacha nai<br/>
                Lage koi apna saga nai<br/>
                Ab jeene ki mil rahi wajah nai<br/>
                Yeah<br/>
                Wo kehti thi, dil se is dil tak ko choolena<br/>
                Hai tere saaye me sukoon har ek vaada kabool bas ye khwaab kabhi toote na
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default WoKehtiThi;
